import { t } from '../../app/i18n';

const types = {
  OTHER: 'OTHER',
  ID_CARD_SCAN_FRONT: 'ID_CARD_SCAN_FRONT',
  ID_CARD_SCAN_BACK: 'ID_CARD_SCAN_BACK',
  PASSPORT_SCAN: 'PASSPORT_SCAN',
  DRIVERS_LICENSE_SCAN: 'DRIVERS_LICENSE_SCAN',
  HEALTH_INSURANCE_SCAN: 'HEALTH_INSURANCE_SCAN',
  BANK_ACCOUNT_STATEMENT_1: 'BANK_ACCOUNT_STATEMENT_1',
  PAYROLL_STATEMENT_1: 'PAYROLL_STATEMENT_1',
  BANK_ACCOUNT_STATEMENT_2: 'BANK_ACCOUNT_STATEMENT_2',
  PAYROLL_STATEMENT_2: 'PAYROLL_STATEMENT_2',
  FACE_IMAGE: 'FACE_IMAGE',
};

export const userDocumentTypes = [
  types.ID_CARD_SCAN_FRONT,
  types.ID_CARD_SCAN_BACK,
  types.PASSPORT_SCAN,
  types.DRIVERS_LICENSE_SCAN,
  types.HEALTH_INSURANCE_SCAN,
  types.BANK_ACCOUNT_STATEMENT_1,
  types.PAYROLL_STATEMENT_1,
  types.BANK_ACCOUNT_STATEMENT_2,
  types.PAYROLL_STATEMENT_2,
];

export const documentObligations = {
  REQUIRED: 'REQUIRED',
  OPTIONAL: 'OPTIONAL',
};

export const optionalTypes = [
  types.PASSPORT_SCAN,
  types.DRIVERS_LICENSE_SCAN,
  types.HEALTH_INSURANCE_SCAN,
];

export const translation = {
  [types.OTHER]: t('Nezaradené'),
  [types.ID_CARD_SCAN_FRONT]: t('Nahrajte občiansky preukaz - predná strana'),
  [types.ID_CARD_SCAN_BACK]: t('Nahrajte občiansky preukaz - zadná strana'),
  [types.PASSPORT_SCAN]: t('Pas'),
  [types.DRIVERS_LICENSE_SCAN]: t('Vodičský preukaz'),
  [types.HEALTH_INSURANCE_SCAN]: t('Zdravotná kartička'),
  [types.BANK_ACCOUNT_STATEMENT_1]: t('Výpis z účtu 1 '),
  [types.PAYROLL_STATEMENT_1]: t('Výplatná páska 1'),
  [types.BANK_ACCOUNT_STATEMENT_2]: t('Výpis z účtu 2 '),
  [types.PAYROLL_STATEMENT_2]: t('Výplatná páska 2'),
  [types.FACE_IMAGE]: t('Fotka tváre'),
};

export const allowedMimeTypes = [
  {
    mediaType: 'image/jpeg',
    suffixes: ['jpg', 'jpeg'],
  },
  {
    mediaType: 'image/png',
    suffixes: ['png'],
  },
  {
    mediaType: 'application/pdf',
    suffixes: ['pdf'],
  },
];

export default types;



// WEBPACK FOOTER //
// ./src/common/enums/accountDocumentTypes.js